'use client';

import { c as _c } from "react/compiler-runtime";
import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import { Cmdo } from './cmdo';
import Orchestra from './orchestra';
const Studio = dynamic(() => import('./theatre/studio').then(({
  Studio
}) => Studio), {
  ssr: false
});
const Stats = dynamic(() => import('./stats').then(({
  Stats
}) => Stats), {
  ssr: false
});
const GridDebugger = dynamic(() => import('./grid').then(({
  GridDebugger
}) => GridDebugger), {
  ssr: false
});
const Minimap = dynamic(() => import('./minimap').then(({
  Minimap
}) => Minimap), {
  ssr: false
});
export function OrchestraTools() {
  const $ = _c(17);
  const {
    stats,
    grid,
    studio,
    dev,
    minimap
  } = useOrchestra();
  let t0;
  let t1;
  if ($[0] !== dev) {
    t0 = () => {
      document.documentElement.classList.toggle("dev", dev);
    };
    t1 = [dev];
    $[0] = dev;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Cmdo />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== studio) {
    t3 = studio && <Studio />;
    $[4] = studio;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== stats) {
    t4 = stats && <Stats />;
    $[6] = stats;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== grid) {
    t5 = grid && <GridDebugger />;
    $[8] = grid;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== minimap) {
    t6 = minimap && <Minimap />;
    $[10] = minimap;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t7 = <>{t2}{t3}{t4}{t5}{t6}</>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}
export function useOrchestra() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [state, setState] = useState(t0);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (!Orchestra) {
        return;
      }
      const usubscribe = Orchestra.subscribe(setState);
      return usubscribe;
    };
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return state;
}